import { useState } from "react";

import {
  addClickRecord,
  formatCalendarDate,
  formatTimestampDate,
  getCaseId,
  getClientId,
} from "../../../Utils/helper";
import incident from "../../../../public/bp_assets/img/incident.svg";
import useClientPage from "../../new-client-dashboard/tabs/contact-panel/hooks/useClientPage";
import NewCaseExistingClientModalClientPage from "../../new-client-dashboard/modals/new-case-existing-client-modal";
import addIconGold from "../../../assets/Add-icon-gold.svg";
import ContactPanelForTreatment from "../../TreatmentPage/components/ContactPanelForTreatment";

// import useClientRelationship from "./hooks/useClientRelationship";

const RelationshipTabHourly = ({ client_cases, refetch }) => {
  const [showAddNewCaseExisitingClient, setShowNewCaseExistingClientModal] = useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  // const { , refetch } = useClientRelationship();
  const { clientData, refetch: _refetchClient } = useClientPage(getClientId(), getCaseId());
  const company = clientData?.client?.companyID;
  const mainContact = clientData?.client?.contact_1;
  const secondaryContact = clientData?.client?.contact_2;
  const AccidentLocationBtnData = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-15 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];
  return (
    <>
      <div
        className="d-flex m-b-5"
        style={{
          gap: "0px",
        }}
      >
        {" "}
        <div
          className="d-flex flex-column "
          style={{
            gap: "5px",
          }}
        >
          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={company?.id || null}
              panel_name="Client"
              className="m-b-0"
              dynamic_label={"Company Name"}
              pageName={"ClientHourly"}
              websiteURL={company?.website || ""}
              name={company?.name || clientData?.client?.entity_name || ""}
              address1={company?.address1 || ""}
              address2={company?.address2 || ""}
              city={company?.city || ""}
              state={company?.state || ""}
              zip_code={company?.zip || ""}
              phone_number={company?.phone_number || ""}
              email={company?.email || ""}
              fax_number={company?.fax || ""}
              onSelectObject={() => {}}
              buttonData={AccidentLocationBtnData}
              genrate_doc_address="Accident Location"
            />
          </div>

          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={mainContact?.id || null}
              panel_name="Main Contact"
              className="m-b-0"
              pageName={"ClientHourly"}
              websiteURL={mainContact?.website || ""}
              name={mainContact?.name || ""}
              address1={mainContact?.address1 || ""}
              address2={mainContact?.address2 || ""}
              city={mainContact?.city || ""}
              state={mainContact?.state || ""}
              zip_code={mainContact?.zip || ""}
              phone_number={mainContact?.phone_number || ""}
              email={mainContact?.email || ""}
              fax_number={mainContact?.fax || ""}
              onSelectObject={() => {}}
              buttonData={AccidentLocationBtnData}
              genrate_doc_address="Accident Location"
            />
          </div>

          <div className="min-w-260px-client">
            <ContactPanelForTreatment
              id={secondaryContact?.id || null}
              panel_name="Secondary Contact"
              className="m-b-0"
              pageName={"ClientHourly"}
              websiteURL={secondaryContact?.website || ""}
              name={secondaryContact?.name || ""}
              address1={secondaryContact?.address1 || ""}
              address2={secondaryContact?.address2 || ""}
              city={secondaryContact?.city || ""}
              state={secondaryContact?.state || ""}
              zip_code={secondaryContact?.zip || ""}
              phone_number={secondaryContact?.phone_number || ""}
              email={secondaryContact?.email || ""}
              fax_number={secondaryContact?.fax || ""}
              onSelectObject={() => {}}
              buttonData={AccidentLocationBtnData}
              genrate_doc_address="Accident Location"
            />
          </div>
        </div>
        <div
          style={{
            width: "100%",
          }}
        >
          <div className="menu-bar-style w-100">
            <div
              className="client-contact-title text-center w-100 d-flex align-items-center justify-content-center"
              style={{ height: "25px" }}
            >
              Case History
            </div>
          </div>
          <div
            className="table-responsive table--no-card border-0 has-alternate-grey insurance-col-table panel-notes-section-height"
            style={{
              height: "425px",
              overflowY: "scroll",
              scrollbarWidth: "none",
            }}
          >
            <table className="table table-borderless table-striped table-earning">
              <tbody className="tbody-panels">
                {client_cases?.length > 0 &&
                  client_cases.map((cases, index) => (
                    <tr className="" key={`case-${cases?.id || index}`}>
                      <td
                        className="height-21 text-start d-flex align-items-center"
                        id="clientHistoryCaseIconPadding"
                      >
                        <span className="ic ic-19 m-r-5">
                          <img src={cases?.case_type?.icon} alt="" />
                        </span>
                        <span
                          className="white-space-nowrap"
                          style={{
                            fontSize: "14px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          {cases?.case_type?.name}
                        </span>
                      </td>
                      <td className="height-21 text-start" id="clientHistoryCaseIconPadding">
                        {cases.incident_date ? (
                          <span className="height-21 d-flex align-items-center">
                            <img src={incident} alt="primary" className="ic-19 m-r-5" />
                            <span className="font-weight-semibold">
                              {formatCalendarDate(cases?.incident_date)}
                            </span>
                          </span>
                        ) : null}
                      </td>
                      <td className="height-21 text-center" id="clientHistoryCaseIconPadding">
                        {cases?.auto_case_stage &&
                          cases?.auto_case_stage?.length > 0 &&
                          cases?.auto_case_stage?.map((stages, stageIndex) => (
                            <span
                              key={`stage-${stageIndex}`}
                              className="font-weight-semibold p-r-5"
                            >
                              {stages}
                            </span>
                          ))}
                      </td>
                      <td className="height-21 text-end" id="clientHistoryCaseIconPadding">
                        {cases.open === "True" ? (
                          <>
                            <span className="color-green fw-bold m-r-5">OPEN:</span>
                            <span className="font-weight-semibold">
                              {formatTimestampDate(cases?.date_open)}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="colorgrey-2 fw-bold m-r-5">CLOSED</span>
                            <span className="font-weight-semibold">
                              {formatCalendarDate(cases?.date_closed)}
                            </span>
                          </>
                        )}
                      </td>
                    </tr>
                  ))}

                {[...Array(12 - client_cases?.length)].map((_, index) => (
                  <tr key={`additional-${index}`} className="fake-row-2" style={{ height: "21px" }}>
                    <td
                      colSpan="4"
                      id="padding-new-case-history"
                      style={{
                        height: "21px",
                      }}
                    >
                      &nbsp;
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            onClick={() => {
              addClickRecord(999, 2);
              setShowNewCaseExistingClientModal(!showAddNewCaseExisitingClient);
            }}
            style={{
              backgroundColor: "var(--primary-10)",
              color: "var(--primary)",
              border: "1px solid var(--primary)",
            }}
            className="btn info-panel-button-hover-state w-100 font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center mt-0"
          >
            <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
              <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
            </span>
            New Case For Client
          </button>
        </div>
      </div>

      {showAddNewCaseExisitingClient && (
        <>
          <NewCaseExistingClientModalClientPage
            handleClose={() => {
              addClickRecord(999, 2);
              setShowNewCaseExistingClientModal(false);
            }}
            show={showAddNewCaseExisitingClient}
            refetch={refetch}
          />
        </>
      )}
    </>
  );
};

export default RelationshipTabHourly;
